import { Component, EventEmitter, Inject, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { STORAGE_KEYS, StorageKeys, StorageService } from 'library-explorer';
import { SlideDTO } from 'src/app/model/slideDTO.model';

@Component({
    selector: 'app-slide-buckets',
    templateUrl: './slide-buckets.component.html',
    styleUrls: ['./slide-buckets.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SlideBucketsComponent implements OnInit {

  @Input() public slideData!: SlideDTO;
  @Input() public animationEnabled = true;

  public showInformationOverlay = false;

  @Output() public interactionCompleted: EventEmitter<number> = new EventEmitter();

  constructor(
    @Inject(STORAGE_KEYS) public storageKeys: StorageKeys,
    private readonly storageService: StorageService
  ) {
  }

  ngOnInit() {
    const overlaySeen = this.storageService.getItem(this.storageKeys.SLIDE_BUCKETS_TOOLTIP_SEEN);

    if (!overlaySeen) {
      this.openInformationOverlay();
    }
  }

  public openInformationOverlay(): void {
    this.showInformationOverlay = true;
  }

  public closeInformationOverlay(): void {
    this.storageService.setItem(this.storageKeys.SLIDE_BUCKETS_TOOLTIP_SEEN, 'true');
    this.showInformationOverlay = false;
  }

}

